const LOG_TABS = [
  ['alerts', '告警历史'],
  ['errors', '运行异常'],
  ['product-research', '选品 AB 操作'],
  ['operations', '管理操作'],
  ['agent-audit', 'Agent 安全'],
  ['usage', 'API / 用量'],
];

function createEventsElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createTable(headers, rows, emptyMessage) {
  const table = createEventsElement('table', 'cc-table');
  const head = document.createElement('thead');
  const headRow = document.createElement('tr');
  headRow.append(...headers.map((header) => createEventsElement('th', '', header)));
  head.append(headRow);
  const body = document.createElement('tbody');
  if (rows.length) {
    body.append(...rows);
  } else {
    const row = document.createElement('tr');
    const cell = createEventsElement('td', 'muted', emptyMessage);
    cell.colSpan = headers.length;
    row.append(cell);
    body.append(row);
  }
  table.append(head, body);
  const scroll = createEventsElement('div', 'cc-table-scroll');
  scroll.append(table);
  return scroll;
}

function createCell(text = '', className = '') {
  return createEventsElement('td', className, String(text ?? ''));
}

function createTagCell(text, className = '') {
  const cell = document.createElement('td');
  cell.append(createEventsElement('span', `cc-tag ${className}`, text));
  return cell;
}

function createOperationCell(label, code) {
  const cell = document.createElement('td');
  cell.append(createEventsElement('strong', '', label), createEventsElement('div', 'mono', code || ''));
  return cell;
}

function createDetailButton(payload) {
  const button = createEventsElement('button', 'btn btn-sm', '详情');
  button.type = 'button';
  button.dataset.ccOpen = JSON.stringify(payload);
  const cell = document.createElement('td');
  cell.append(button);
  return cell;
}

function createLogPayload(row) {
  return {
    id: row.id,
    action: row.action || row.action_type || row.source || row.alert_type,
    outcome: row.outcome || row.status || row.send_status,
    trace: row.trace_id,
    msg: row.error_message || row.message || row.endpoint || row.title || '',
    ts: row.created_at,
    module: row.module || row.api_type || row.alert_key,
    actor: row.actor_name || row.user_name || row.user_id,
    meta: row.metadata_json || null,
    durations: row.step_durations_json || null,
  };
}

function createSummaryRow(row, helpers) {
  const key = String(row.group_key || 'unknown');
  const failures = Number(row.failure_count || 0);
  const secondary = String(row.secondary || '');
  const primary = document.createElement('td');
  primary.append(createEventsElement('strong', '', helpers.logGroupLabel(helpers.tab, key)), createEventsElement('div', 'mono', key));
  const secondaryCell = helpers.tab === 'usage'
    ? createOperationCell(helpers.operationLabel(secondary), secondary)
    : createCell(secondary || '—');
  const action = createEventsElement('button', 'btn btn-sm', '查看明细');
  action.type = 'button';
  action.dataset.ccLogGroup = key;
  const actionCell = document.createElement('td');
  actionCell.append(action);
  const rowElement = document.createElement('tr');
  rowElement.append(
    primary,
    secondaryCell,
    createTagCell(helpers.statusLabel(row.status), helpers.statusTagClass(row.status, failures)),
    (() => { const cell = document.createElement('td'); cell.append(createEventsElement('strong', '', Number(row.event_count || 0))); return cell; })(),
    createCell(failures, failures > 0 ? 'delta-warn' : ''),
    createCell(helpers.formatCcTime(row.last_at)),
    actionCell,
  );
  return rowElement;
}

function createLogRow(row, tab, helpers) {
  const payload = createLogPayload(row);
  const tr = document.createElement('tr');
  if (tab === 'alerts') {
    const level = String(row.alert_level || 'unknown');
    tr.append(
      createCell(row.id),
      createTagCell(helpers.statusLabel(level), ['critical', 'error', 'high'].includes(level) ? 'bad' : 'warn'),
      createOperationCell(helpers.logGroupLabel('alerts', row.alert_type), row.alert_type),
      createCell(row.title || ''),
      createCell(row.channel === 'feishu' ? '飞书' : row.channel || '—'),
      createCell(helpers.statusLabel(row.send_status)),
      createCell(helpers.formatCcTime(row.created_at)),
      createDetailButton(payload),
    );
    return tr;
  }
  if (tab === 'operations') {
    tr.append(
      createCell(row.id),
      createCell(row.actor_name || row.actor_user_id || ''),
      createOperationCell(helpers.actionLabel(row.action), row.action),
      createCell([row.target_type, row.target_id].filter(Boolean).join(' ') || '—'),
      createTagCell(helpers.statusLabel(row.outcome), row.outcome === 'success' ? 'ok' : 'warn'),
      createCell(row.trace_id || '', 'mono'),
      createCell(helpers.formatCcTime(row.created_at)),
      createDetailButton(payload),
    );
    return tr;
  }
  if (tab === 'product-research') {
    const status = String(row.status || 'unknown');
    const tone = ['success', 'completed'].includes(status) ? 'ok' : ['failed', 'error'].includes(status) ? 'bad' : 'warn';
    tr.append(
      createCell(row.id),
      createCell(row.user_name || row.user_email || row.user_id || ''),
      createOperationCell(helpers.actionLabel(row.action_type), row.action_type),
      createTagCell(helpers.statusLabel(status), tone),
      createCell([row.site_code, row.model_code].filter(Boolean).join(' / ') || '—'),
      createCell(row.job_id || row.trace_id || '—', 'mono'),
      createCell(helpers.formatCcTime(row.created_at)),
      createDetailButton(payload),
    );
    return tr;
  }
  if (tab === 'agent-audit') {
    tr.append(
      createCell(row.id),
      createCell(row.user_id),
      createOperationCell(helpers.actionLabel(row.action), row.action),
      createCell(row.tool_code || '—'),
      createCell(helpers.statusLabel(row.status)),
      createCell(row.latency_ms != null ? helpers.ms(row.latency_ms) : '—'),
      createCell(helpers.formatCcTime(row.created_at)),
      createDetailButton(payload),
    );
    return tr;
  }
  if (tab === 'usage') {
    tr.append(
      createCell(row.id),
      createCell(row.user_id),
      createOperationCell(helpers.providerLabel(row.api_type), row.api_type),
      createOperationCell(helpers.operationLabel(row.endpoint), row.endpoint),
      createCell(row.duration_ms != null ? helpers.ms(row.duration_ms) : '—'),
      createCell(row.status_code ?? '未采集'),
      createCell(helpers.formatCcTime(row.created_at)),
      createDetailButton(payload),
    );
    return tr;
  }
  const source = document.createElement('td');
  source.append(document.createTextNode(helpers.serviceLabel(row.source)), createEventsElement('div', 'mono', row.source || ''));
  tr.append(
    createCell(row.id),
    source,
    createCell(helpers.serviceLabel(row.module)),
    createCell(row.trace_id || '', 'mono'),
    createCell(String(row.error_message || '').slice(0, 120)),
    createCell(helpers.formatCcTime(row.created_at)),
    createDetailButton(payload),
  );
  return tr;
}

function createPager(data) {
  const total = Number(data.total || 0);
  const page = Number(data.page || 1);
  const size = Number(data.size || 20);
  const pages = Math.max(1, Math.ceil(total / size));
  const pager = createEventsElement('div', 'cc-pager');
  const previous = createEventsElement('button', 'btn btn-sm', '上一页');
  previous.type = 'button';
  previous.dataset.ccPage = String(page - 1);
  previous.disabled = page <= 1;
  const next = createEventsElement('button', 'btn btn-sm', '下一页');
  next.type = 'button';
  next.dataset.ccPage = String(page + 1);
  next.disabled = page >= pages;
  pager.append(previous, createEventsElement('span', 'muted', `${page} / ${pages} · 共 ${total}`), next);
  return pager;
}

function createSummary(data, helpers) {
  if (data.available === false) return createEventsElement('div', 'cc-error', '摘要数据暂时不可用，请稍后重试。');
  const fragment = document.createDocumentFragment();
  const metrics = createEventsElement('div', 'cc-grid-2 cc-log-summary-grid');
  [['近 ' + Number(data.windowDays || 7) + ' 天记录', Number(data.eventCount || 0)], ['业务分类', Number(data.groupCount || 0)]].forEach(([label, value]) => {
    const card = createEventsElement('div', 'cc-card');
    card.append(createEventsElement('div', 'label', label), createEventsElement('div', 'value', value));
    metrics.append(card);
  });
  fragment.append(metrics, createTable(
    ['业务分类', '对象', '状态', '记录数', '异常数', '最近发生', '操作'],
    (data.rows || []).map((row) => createSummaryRow(row, { ...helpers, tab: data.tab })),
    '当前时间范围内暂无记录',
  ));
  return fragment;
}

function createDetails(data, helpers) {
  if (data.available === false) return createEventsElement('div', 'cc-error', '日志数据暂时不可用，请稍后重试。');
  const headers = {
    alerts: ['编号', '级别', '告警类型', '标题', '通知渠道', '发送状态', '时间', '操作'],
    errors: ['编号', '来源', '模块', '追踪编号', '错误信息', '时间', '操作'],
    'product-research': ['编号', '用户', '业务动作', '状态', '站点 / 分片', '任务 / 追踪编号', '时间', '操作'],
    operations: ['编号', '操作人', '业务动作', '操作对象', '结果', '追踪编号', '时间', '操作'],
    'agent-audit': ['编号', '用户', '业务动作', '工具', '状态', '耗时', '时间', '操作'],
    usage: ['编号', '用户', '服务类型', '调用入口', '耗时', '状态码', '时间', '操作'],
  }[data.tab] || ['编号', '信息'];
  const fragment = document.createDocumentFragment();
  fragment.append(
    createTable(headers, (data.rows || []).map((row) => createLogRow(row, data.tab, helpers)), '暂无记录'),
    createPager(data),
  );
  return fragment;
}

export function renderCommandCenterEventsShell(root, state) {
  if (!root) return;
  const tabs = createEventsElement('div', 'cc-subtabs');
  tabs.id = 'cc-log-subtabs';
  LOG_TABS.forEach(([key, label]) => {
    const button = createEventsElement('button', key === state.tab ? 'active' : '', label);
    button.type = 'button';
    button.dataset.ccLogtab = key;
    tabs.append(button);
  });
  const filters = createEventsElement('div', 'cc-filters');
  [['summary', '摘要视图'], ['detail', '明细记录']].forEach(([mode, label]) => {
    const button = createEventsElement('button', `btn ${state.mode === mode ? 'btn-primary' : 'btn-secondary'}`, label);
    button.type = 'button';
    button.dataset.ccLogMode = mode;
    filters.append(button);
  });
  const search = createEventsElement('input', 'search-input');
  search.type = 'search';
  search.id = 'cc-logs-q';
  search.placeholder = '业务名称、用户、任务编号或追踪编号';
  search.value = state.query || '';
  const query = createEventsElement('button', 'btn btn-primary', '查询');
  query.type = 'button';
  query.id = 'cc-logs-go';
  filters.append(search, query);
  if (state.tab === 'errors' && state.mode === 'detail') {
    [['clear-old', '清理 30 天前错误'], ['clear-all', '清空全部错误']].forEach(([action, label]) => {
      const button = createEventsElement('button', 'btn btn-secondary', label);
      button.type = 'button';
      button.dataset.ccLogAction = action;
      filters.append(button);
    });
  }
  const output = createEventsElement('div', 'cc-card');
  output.id = 'cc-logs-table';
  output.append(createEventsElement('div', 'cc-loading', '加载中…'));
  root.replaceChildren(tabs, filters, output);
}

export function setCommandCenterLogsLoading(root) {
  root.replaceChildren(createEventsElement('div', 'cc-loading', '加载中…'));
}

export function renderCommandCenterLogs(root, data, helpers) {
  root.replaceChildren(data.mode === 'summary' ? createSummary(data, helpers) : createDetails(data, helpers));
}

export function renderCommandCenterLogsError(root, message) {
  root.replaceChildren(createEventsElement('div', 'cc-error', `日志加载失败：${message || '未知错误'}`));
}
